import { formatNum } from '@app/utils/math';

type XAxisConfig = {
  bandSize?: number;
  scale?: {
    (value: string): number;
    bandwidth?: () => number;
  };
};

type YAxisConfig = {
  ticks?: Array<number>;
  scale?: (value: number) => number;
};

type Props = {
  xAxisMap?: Record<string, XAxisConfig>;
  yAxisMap?: Record<string, YAxisConfig>;
  offset?: { left: number; top: number };
  data?: Array<{
    name: string;
    quarterValue: number;
  }>;
};

export const CustomQuarterLabel = ({ xAxisMap, yAxisMap, offset, data }: Props) => {
  if (!xAxisMap || !yAxisMap || !offset || !data) return null;

  const xAxis = xAxisMap[Object.keys(xAxisMap)[0]];
  const yAxis = yAxisMap[Object.keys(yAxisMap)[0]];

  const getBand = () =>
    typeof xAxis.bandSize === 'number'
      ? xAxis.bandSize
      : xAxis.scale && typeof xAxis.scale.bandwidth === 'function'
        ? xAxis.scale.bandwidth()
        : 0;

  const band = getBand();

  return (
    <g>
      {data.map((item, index) => {
        if (index % 3 !== 2) return null;

        const value = item.quarterValue;
        if (!value || value === 0) return null;

        const x0 = xAxis.scale?.(item.name);
        if (x0 == null || Number.isNaN(x0)) return null;

        const y0 = yAxis.scale?.(value);
        if (y0 == null || Number.isNaN(y0)) return null;

        const rightOffset = 80;
        const cx = offset.left + x0 + band - rightOffset;
        const cy = offset.top + y0;

        const formattedValue = formatNum(value, 0, 0);
        const text = `${formattedValue} Ph`;
        const padX = 8;
        const charW = 6;
        const rectH = 22;
        const rectW = text.length * charW + padX * 2;
        const verticalOffset = 36;

        return (
          <g key={`q-label-${index}`}>
            <rect
              x={cx - rectW}
              y={cy - rectH - verticalOffset}
              width={rectW}
              height={rectH}
              rx={8}
              fill="#405454"
            />
            <text
              x={cx - rectW / 2}
              y={cy - rectH / 2 - verticalOffset}
              textAnchor="middle"
              dominantBaseline="middle"
              fill="#FFF"
              fontSize={10}
              fontWeight={600}
              fontFamily="Inter"
            >
              {text}
            </text>
          </g>
        );
      })}
    </g>
  );
};
